import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CustomOrderListState } from "../../../features/view/public/customOrders/customOrderTypes";
import {
  fetchCustomOrderDetails,
  getCustomOrderList,
  setCustomOrder,
} from "./CustomOrderApi";

const initialState: CustomOrderListState = {
  customOrderList: { data: [], loader: false },
  customOrderDescription: { data: {}, loader: false },
  customOrderId: null,
  loader: false,
};

export const getCustomOrderListAsync = createAsyncThunk(
  "products/custom-products",
  async () => {
    const response = await getCustomOrderList();
    return response;
  }
);

export const getCustomOrderDetailsAsync = createAsyncThunk(
  "products/custom-products-details",
  async (product_id: any) => {
    const response = await fetchCustomOrderDetails(product_id);
    return response;
  }
);

export const setCustomOrderAsync = createAsyncThunk(
  "orders/customorder/1/",
  async ({ id, payload }: { id: any; payload: any }) => {
    const response = await setCustomOrder(id, payload);
    return response;
  }
);

export const CustomOrderSlice = createSlice({
  name: "customOrderList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getCustomOrderListAsync.pending, (state) => {
        state.customOrderList.loader = true;
      })
      .addCase(getCustomOrderListAsync.fulfilled, (state, action: any) => {
        state.customOrderList.loader = false;
        state.customOrderList.data = action?.payload?.data || [];
      })
      .addCase(getCustomOrderListAsync.rejected, (state) => {
        state.customOrderList.loader = false;
      })
      .addCase(getCustomOrderDetailsAsync.pending, (state) => {
        state.customOrderDescription.loader = true;
      })
      .addCase(getCustomOrderDetailsAsync.fulfilled, (state, action: any) => {
        state.customOrderDescription.loader = false;
        state.customOrderDescription.data = action?.payload?.data?.data || [];
      })
      .addCase(getCustomOrderDetailsAsync.rejected, (state) => {
        state.customOrderDescription.loader = false;
      })
      .addCase(setCustomOrderAsync.pending, (state) => {
        state.loader = true;
      })
      .addCase(setCustomOrderAsync.fulfilled, (state, action: any) => {
        state.loader = false;
      })
      .addCase(setCustomOrderAsync.rejected, (state) => {
        state.loader = false;
      });
  },
});

export default CustomOrderSlice.reducer;
